const  projectsLaravel = [
    {
       proTitle: "Laravel projects", 
       projectProps: [
            {
                title: "Rss feed reader",
                img: "./img_projects/laravel/project1.png",
                desc: "It allows you to get news from the main online news producers.",
                long_desc: "This project allows to get news via gooogle news RSS file, to use the features, go to the news item of your interest, click to select it, then press the 'Alt' key to bring up the button that points to the link of the news.",
                topics: "PHP, OOP, MySQL, Javascript, HTML/CSS, XML",
                location_url: "https://github.com/pippo-github/laravel-rss-feed-reader",
                source_code: true
            },
            {
                title: "User Post",
                img: "./img_projects/Laravel/project2.png",
                desc: "Post application:  create, edit or delete their own posts.",
                long_desc: "The project is focused on connections to the database, in particular with relationships between tables of type one (user) to many (Posts), the application presents itself with a home page where through a navigation bar it allows to select the service route, the user not logged in can navigate in all parts of the site except the route: \"Posts\", as to access this area the user must be authenticated, if the user is not authorized and tries to access this section, he is invited to log on.",
                topics: "PHP, OOP, ORM Eloquent, Auth",
                location_url: "https://github.com/pippo-github/laravel-user-post",
                source_code: true
            },
        ]
    }
]

export {projectsLaravel}
